export enum RedPermissionState {
  INITIAL = 'init',
  LOADING = 'loading',
  LOAD_SUCCESSFUL = 'load_successful',
  LOAD_FAILED = 'load_failed',
}

export type RedPermissionStateType = RedPermissionState;
